import router from "@/router/index";
import store from "@/store/store";
import axios from "axios";

axios.defaults.validateStatus = () => {
  return status < 500;
};

export class API {
  constructor(mode) {
    const app_mode = store.state.config.system.isCreation ? "creation" : "player";

    this.baseUrl = "";

    switch (mode) {
      case "db":
        this.baseUrl = store.state.config.url.db[app_mode];
        break;
      case "explore":
        this.baseUrl = store.state.config.url.explorer[app_mode];
        break;
      case "geo":
        this.baseUrl = "https://geo.api.gouv.fr";
        break;
      case "weather":
        this.baseUrl = "https://api.open-meteo.com/v1";
        break;
      default:
        break;
    }
  }

  getAuthHeaders() {
    // Get token from store
    const token = store.state.user.token;

    // Si la route n'est pas vers votre propre API, n'ajoutez pas le token (ex: geo, weather)
    if (!token || this.baseUrl.includes("api.gouv.fr") || this.baseUrl.includes("open-meteo.com")) {
      return {};
    }

    // Le format standard pour l'authentification JWT est "Bearer <token>"
    return {
      Authorization: `Bearer ${token}`,
    };
  }

  get(path) {
    return axios
      .get(this.baseUrl + path, { headers: this.getAuthHeaders() })
      .then((response) => this.handleResponse(response))
      .catch((err) => {
        throw err;
      });
  }

  post(path, body) {
    return axios
      .post(this.baseUrl + path, body, { headers: this.getAuthHeaders() })
      .then((response) => this.handleResponse(response))
      .catch((err) => {
        throw err;
      });
  }

  delete(path, body) {
    return axios
      .delete(this.baseUrl + path, { data: body, headers: this.getAuthHeaders() })
      .then((response) => this.handleResponse(response))
      .catch((err) => {
        throw err;
      });
  }

  put(path, body) {
    return axios
      .put(this.baseUrl + path, body, { headers: this.getAuthHeaders() })
      .then((response) => this.handleResponse(response))
      .catch((err) => {
        throw err;
      });
  }

  upload(path, formData) {
    const authHeaders = this.getAuthHeaders();

    return axios
      .post(this.baseUrl + path, formData, {
        headers: { "Content-Type": "multipart/form-data", ...authHeaders },
      })
      .then((response) => this.handleResponse(response))
      .catch((err) => {
        throw err;
      });
  }

  handleResponse(response) {
    if (response.status == 401) {
      router.push("/login");
      throw new Error("Authentification expired or invalid");
    }
    if (response.status == 500) {
      throw response;
    }
    return response;
  }
}

export const db = new API("db");
export const explore = new API("explore");
export const geo = new API("geo");
export const weather = new API("weather");
